import { LOGIN_FAIL, LOGIN_SUCCESS, LOGOUT, PROFILE_UPDATE } from "./type";
import { jwtDecode } from "jwt-decode";
import { APIURL } from "./config";
import axios from "axios";
import { toast } from "react-toastify";

// decode email and passwod to remeber
const encodeData = (str) => btoa(unescape(encodeURIComponent(str)));
console.log("APIURL >>", APIURL);
export const login =
  ({ email, password, remember }) =>
  async (dispatch) => {
    var body = JSON.stringify({
      email,
      password,
      position: "user_admin",
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        `${APIURL}/api/v1/users/login`,
        body,
        config,
      );
      if (res?.data?.status === "success") {
        try {
          const decoded = jwtDecode(res.data.token);
          console.log("Decoded Token Position:", decoded.position);

          if (decoded.position === "user_admin") {
            dispatch({
              type: LOGIN_SUCCESS,
              payload: res.data,
            });
            toast.success("Admin Logged In Successfully");
            if (remember) {
              const encodeEmail = encodeData(email);
              const encodePassword = encodeData(password);
              localStorage.setItem("rememberEmail", encodeEmail);
              localStorage.setItem("rememberPassword", encodePassword);
              localStorage.setItem("remember", true);
            } else {
              localStorage.removeItem("rememberEmail");
              localStorage.removeItem("rememberPassword");
              localStorage.removeItem("remember");
            }

            setTimeout(() => {
              return (window.location.href = "/dashboard");
            }, 1000);
            return true;
          } else {
            toast.error(
              "Access denied. You do not have sufficient permissions to view this page.",
            );
            dispatch({
              type: LOGIN_FAIL,
            });
            return false;
          }
        } catch (error) {
          console.error("Error decoding token:", error);
          toast.error("An error occurred during login.");
          dispatch({
            type: LOGIN_FAIL,
          });
          return false;
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // toast.error("Please Check Email and Password!", error);
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
      dispatch({
        type: LOGIN_FAIL,
      });
      return false;
    }
  };

export const logout = () => (dispatch) => {
  dispatch({
    type: LOGOUT,
  });
  toast.success("Logged Out Successfully!");
  setTimeout(() => {
    return (window.location.href = "/");
  }, 2000);
};

export const updateProfile = (val, id) => async (dispatch) => {
  var body = JSON.stringify({
    firstName: val?.firstName,
    email: val?.email,
    position: "user_admin",
    image: val?.image,
    phone: val?.phone,
  });
  const token = localStorage.getItem("token");

  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const response = await axios.patch(
      `${APIURL}/api/v1/users/${id}`,
      body,
      config,
    );
    dispatch({ type: PROFILE_UPDATE, payload: response?.data });
    toast.success("Profile Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/dashboard");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const getAdmin = async () => {
  const token = localStorage.getItem("token");
  const id = localStorage.getItem("userId");

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    window.location.href = "/";
  }
  if (!token || !id) return logout();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    await axios.get(`${APIURL}/api/v1/users/${id}`, config);
  } catch (err) {
    logout();
  }
};
